/*
 * Footer Newsletter → existing Klaviyo onsite popup.
 * Does not load klaviyo.js; relies on the app embed / optional theme fallback.
 */
function openKlaviyoForm(formId) {
  if (!formId) return;
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formId]);
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-klaviyo-open]');
  if (!(trigger instanceof HTMLElement)) return;
  event.preventDefault();
  openKlaviyoForm(trigger.getAttribute('data-klaviyo-open'));
});
